import { useState } from "react";
import { changePassword, formatApiErrorDetail } from "@/lib/adminApi";

export default function ChangePasswordModal({ onClose }) {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    if (pw !== confirm) return setError("Passwords do not match");
    setBusy(true);
    try {
      await changePassword(pw, confirm);
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="admin-modal" role="dialog" aria-modal="true" data-testid="password-modal">
      <button className="admin-modal__scrim" onClick={onClose} aria-label="Close" />
      <form className="admin-modal__panel admin-modal__panel--narrow" onSubmit={submit}>
        <div className="admin-modal__top">
          <h2>Change password</h2>
          <button type="button" onClick={onClose} className="admin-mini mono-caps" data-testid="password-modal-close">Close</button>
        </div>
        {done ? (
          <p className="admin-ok" data-testid="password-success">Password updated. Use it the next time you sign in.</p>
        ) : (
          <>
            {error && <p className="admin-error" data-testid="password-error">{error}</p>}
            <label className="admin-field"><span className="mono-caps">New password</span>
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" required data-testid="password-new" />
            </label>
            <label className="admin-field"><span className="mono-caps">Confirm new password</span>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required data-testid="password-confirm" />
            </label>
            <div className="admin-modal__actions">
              <button type="submit" className="admin-btn mono-caps" disabled={busy} data-testid="password-save">
                {busy ? "Saving…" : "Update password"}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
